import { useMutation } from '@tanstack/react-query';
import { UpdateOrganizationSignupDocumentUploadDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useUpdateOrganizationSignupDocumentUpload = (
    organizationId: string,
    onSuccess: () => void,
) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationSignupDocumentUpload', organizationId],
        mutationFn: (body: UpdateOrganizationSignupDocumentUploadDto) =>
            apiClient.fetchApi<{
                signupDocumentUploadEnabled: boolean;
                signupDocumentUploadRequired: boolean;
                signupDocumentUploadTitle: string | null;
                signupDocumentUploadSubtitle: string | null;
            }, UpdateOrganizationSignupDocumentUploadDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/signup-document-upload`,
                body,
            }),
        onSuccess: (data) => {
            onSuccess();
            if (selectedOrganization && organizationId === selectedOrganization.id) {
                setSelectedOrganization({
                    ...selectedOrganization,
                    signupDocumentUploadEnabled: data.signupDocumentUploadEnabled,
                    signupDocumentUploadRequired: data.signupDocumentUploadRequired,
                    signupDocumentUploadTitle: data.signupDocumentUploadTitle,
                    signupDocumentUploadSubtitle: data.signupDocumentUploadSubtitle,
                });
            }
        },
    });
};
